import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    savePackageCreation,
    editData,
    GetAllCollectionPoints,
    GetAllCardsByCollectionPointID,
    getAvailableUsers,
    getOperationEntityByID,
    getCollectionPointByOperationEntityId,
    getPackageFilterData,
    editDataIfSOSTrue,
    GetCollectionPointForPackage,
    GetAllOperationEntityByGroupID
};

async function savePackageCreation(data) {
    let packages = {
        packageID: 0,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        operationalCardID: parseInt(data.operationalCardID),
        aspNetUserId: parseInt(data.aspNetUserId),
        packageCode: data.packageCode,
        packageName: data.packageName.trim(),
        password: data.backupLoginPassword,
        isActive: data.isActive,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }
    const response = await CommonPost('/api/Package/SaveCommonPackage', null, packages);
    return response;
}

async function editData(data) {

    let packages = {
        packageID: data.packageID,
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        operationalCardID: parseInt(data.operationalCardID),
        aspNetUserId: data.aspNetUserId === "-1" ? null : parseInt(data.aspNetUserId),
        packageCode: data.packageCode,
        packageName: data.packageName.trim(),
        password: data.backupLoginPassword,
        isActive: data.isActive,
        createdBy: data.createdBy,
        createdDate: data.createdDate,
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
       
    }
    const response = await CommonPost('/api/Package/UpdateCommonPackage', null, packages);
    return response;

}

async function editDataIfSOSTrue(packageID) {

    const response = await CommonGet('/api/SoS/CheckSoSStateByPackageId', 'packageID=' + packageID);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(id) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetCollectionPointForPackage(id, groupID) {
    var objModel = {
        groupID: groupID,
        operationEntityID: id,
    }
    var collectionPointArray = [];
    const response = await CommonPost('/api/CollectionPoint/GetCollectionPointsForCommonPackage', null, objModel);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return collectionPointArray;
}

async function getPackageFilterData(data) {
    var filtermodel = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        collectionPointID: data.collectionPointID
    }
    const response = await CommonPost('/api/Package/FilterPackage', null, filtermodel);
    return response.data;

}

async function GetAllCardsByCollectionPointID(collectionPointID, operationalCardID) {
    var cardsArray = [];
    let cardFilterModel = {
        collectionpointID: collectionPointID.toString(),
        cardID: operationalCardID.toString()
    };
    const response = await CommonPost('/api/Card/GetAvailabaleOperationCardsForPackages', null, cardFilterModel);
    for (let item of Object.entries(response.data)) {
        cardsArray[item[1]["cardID"]] = item[1]["nameToBePrinted"]
    }
    return cardsArray;
}

async function getAvailableUsers(operationEntityID, userID) {
    if (operationEntityID != '0') {

        var usersArray = [];
        let userFilterModel = {
            operationEntityID: operationEntityID.toString(),
            userID: userID.toString()
        }

        var response = await CommonPostIDServer('/Admin/GetAvailableUsersForPackage', null, userFilterModel);
        for (let item of Object.entries(response.data)) {
            usersArray[item[1]["aspNetUserId"]] = item[1]["userName"]
        }
        return usersArray;
    }
}

async function GetAllOperationEntityByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getOperationEntityByID(operationEntityID) {
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByID', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function getCollectionPointByOperationEntityId(data) {
    var collectionPointArray = [];
    let filterModel = {
        operationEntityID: data.operationEntityID,
        groupID: data.groupID
    }
    var response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, filterModel);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}


